import {ComponentStyleConfig} from '@chakra-ui/react';

export const Button: ComponentStyleConfig = {
  baseStyle: {},
  variants: {
    solid: {
      background: 'primary.400',
      ':hover': {
        background: 'primary.200'
      }
    },
    primary: {
      background: 'primary.300',
      ':hover': {
        background: 'primary.100'
      }
    },

    secondary: ({colorMode}) => ({
      background: colorMode === 'dark' ? 'blackAlpha.600' : 'gray.50',
      fontSize: '14px'
    })
  }
};
